import React from "react";
import Banner from "./";
import { checkImage } from "../../helpers";
import { BannerPropsWrapper, BannerProps } from "./";

const wrapper = (props: BannerPropsWrapper) => {
  if (props.adBanners && props.adBanners.length) {
    return (
      <div className="commercial-banner__container--generic">
        <div
          className={`page-section__inner whatson-hero__ad-banner-wrapper banner-length--${props.adBanners.length}`}
        >
          {props.adBanners.map((b: BannerProps) => (
            <Banner
              imgDesktopURL={
                checkImage({ images: b.imageUrls || [], size: "Large" }) || ""
              }
              imgMobileURL={
                checkImage({ images: b.imageUrls || [], size: "Small" }) || ""
              }
              {...b}
            />
          ))}
        </div>
      </div>
    );
  } else if (props.adBanners && props.adBanners.length == 0) {
    return <></>;
  } else {
    return (
      <Banner
        imgDesktopURL={
          checkImage({ images: props.imageUrls || [], size: "Large" }) || ""
        }
        imgMobileURL={
          checkImage({ images: props.imageUrls || [], size: "Small" }) || ""
        }
        {...props}
      />
    );
  }
};

export default wrapper;
